module.exports = __webpack_public_path__ + "img/yuejuan_task.1f08a970.jpeg";